import type { CommerceErrorCode } from "@teqtank/commerce-contracts";

/** Base error raised by the public Teqtank Commerce SDK. */
export class CommerceError extends Error {
    public readonly code: CommerceErrorCode;
    public readonly details: Readonly<Record<string, unknown>> | undefined;

    public constructor(
        code: CommerceErrorCode,
        message: string,
        details?: Readonly<Record<string, unknown>>,
    ) {
        super(message);
        this.name = "CommerceError";
        this.code = code;
        this.details = details;
    }
}
